module.exports = __webpack_public_path__ + "static/img/northwestern.dc7da4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/northwestern.png
// module id = 17
// module chunks = 0